<template>
  <div>
    <div id="header">
      <div class="inner">
        <h1>Grzegorz Radzi</h1>
        <h2>Jaki sprzęt wybrać?</h2>
        <div class="actions">
          <!-- <a class="btn-red" href="#">Dowiedz się wiecej</a> -->
          <a
            class="btn-transparent"
            href="https://www.youtube.com/user/AmicaAGD"
            target="_blank"
            rel="noopener noreferrer"
          >
            <iconYT></iconYT>Nasz kanał YouTube
          </a>
        </div>
      </div>
    </div>
    <div class="header-mobile-actions">
      <!-- <a class="btn-red" href="#">Dowiedz się wiecej</a> -->
      <a
        class="btn-transparent"
        href="https://www.youtube.com/user/AmicaAGD"
        target="_blank"
        rel="noopener noreferrer"
      >
        <iconYT></iconYT>Nasz kanał YouTube
      </a>
    </div>
    <div id="copy-section">
      <div class="copy-left">
        <p>Poradnik AGD, czyli na co zwrócić uwagę kupując sprzęt do kuchni</p>
      </div>
      <div class="copy-right">
        <p>
          Nowe mieszkanie a może remont? Jeśli zastanawiasz się nad zmianą lub
          zakupem sprzętu AGD, przychodzimy z pomocą! Grzegorz, nasz ekspert,
          razem ze swoją rodziną testował piekarniki, płyty, okapy, zmywarki i
          lodówki Amica. Efekty? Podpowiemy Ci, na co zwrócić szczególna uwagę i
          jak wybrać sprzęt, który ułatwi Ci codzienne obowiązki.
        </p>
        <p>
          Nasze video mają charakter poradnikowy. Mamy nadzieję, że pomogą Ci
          się odnaleźć w świecie nowych funkcji ponieważ przyświeca nam idea
          „projektowania po ludzku”.
        </p>
      </div>
    </div>
    <div id="carousels-nav">
      <h2>Wybierz kategorię sprzętu, która Cię interesuje:</h2>
      <div class="d-flex flex-wrap">
        <div class="nav-inner">
          <a href="#" @click.prevent="scrollToId('piekarniki')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="51.199"
              height="50"
              viewBox="0 0 51.199 50"
            >
              <defs>
                <clipPath id="a">
                  <rect
                    class="a"
                    width="51.199"
                    height="50"
                    transform="translate(-110.233 48.7)"
                  />
                </clipPath>
              </defs>
              <g transform="translate(110.233 -48.7)">
                <g class="b">
                  <path
                    class="a"
                    d="M-66.5,98.7h-36.273a7.412,7.412,0,0,1-7.463-7.344V56.044a7.413,7.413,0,0,1,7.463-7.344H-66.5a7.412,7.412,0,0,1,7.462,7.344V91.356A7.411,7.411,0,0,1-66.5,98.7Zm-36.273-48.006a5.417,5.417,0,0,0-5.469,5.35V91.356a5.417,5.417,0,0,0,5.469,5.35H-66.5a5.416,5.416,0,0,0,5.468-5.35V56.044a5.416,5.416,0,0,0-5.468-5.35Z"
                  />
                </g>
                <path
                  class="a"
                  d="M-65.537,92.482h-38.191V70.5h38.191Zm-36.489-1.7h34.787V72.2h-34.787Zm26.237-29.236H-94.081V54.662h18.292Zm-16.589-1.7h14.886V56.364H-92.378Z"
                />
                <path
                  class="a"
                  d="M-66.023,67.017h-37.35a1,1,0,0,1-1-1,1,1,0,0,1,1-1h37.35a1,1,0,0,1,1,1A1,1,0,0,1-66.023,67.017Z"
                />
              </g>
            </svg>
            Piekarniki
          </a>
          <a href="#" @click.prevent="scrollToId('płyty')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="70.575"
              height="50"
              viewBox="0 0 70.575 50"
            >
              <defs>
                <clipPath id="a">
                  <rect
                    class="a"
                    width="70.575"
                    height="50"
                    transform="translate(-128.588 48.7)"
                  />
                </clipPath>
              </defs>
              <g transform="translate(128.588 -48.7)">
                <g class="b">
                  <path
                    class="a"
                    d="M-74.916,74.91a9.351,9.351,0,0,0-9.338,9.342A9.351,9.351,0,0,0-74.916,93.6a9.353,9.353,0,0,0,9.338-9.343,9.353,9.353,0,0,0-9.338-9.342m0,20.575A11.243,11.243,0,0,1-86.148,84.252,11.243,11.243,0,0,1-74.916,73.019,11.244,11.244,0,0,1-63.683,84.252,11.244,11.244,0,0,1-74.916,95.485m-34.928-17.4a7.617,7.617,0,0,0-7.606,7.606,7.618,7.618,0,0,0,7.606,7.61,7.615,7.615,0,0,0,7.606-7.61,7.614,7.614,0,0,0-7.606-7.606m0,17.111a9.516,9.516,0,0,1-9.5-9.505,9.512,9.512,0,0,1,9.5-9.5,9.509,9.509,0,0,1,9.5,9.5,9.512,9.512,0,0,1-9.5,9.505m34.39-41.218a7.613,7.613,0,0,0-7.6,7.606,7.614,7.614,0,0,0,7.6,7.61,7.62,7.62,0,0,0,7.615-7.61,7.619,7.619,0,0,0-7.615-7.606m0,17.111a9.511,9.511,0,0,1-9.5-9.505,9.511,9.511,0,0,1,9.5-9.5,9.512,9.512,0,0,1,9.505,9.5,9.513,9.513,0,0,1-9.505,9.505m-34.6-17.152a9.346,9.346,0,0,0-9.338,9.338,9.349,9.349,0,0,0,9.338,9.342,9.353,9.353,0,0,0,9.338-9.342,9.349,9.349,0,0,0-9.338-9.338m0,20.575A11.247,11.247,0,0,1-121.289,63.27a11.244,11.244,0,0,1,11.233-11.233A11.243,11.243,0,0,1-98.828,63.27a11.247,11.247,0,0,1-11.228,11.237M-125.038,50.6a1.99,1.99,0,0,0-1.655,2.166V94.639a1.99,1.99,0,0,0,1.655,2.166h63.476a1.965,1.965,0,0,0,1.655-2.166V52.761A1.965,1.965,0,0,0-61.562,50.6Zm63.476,48.1h-63.476a3.836,3.836,0,0,1-3.55-4.061V52.761a3.836,3.836,0,0,1,3.55-4.061h63.476a3.836,3.836,0,0,1,3.55,4.061V94.639a3.836,3.836,0,0,1-3.55,4.061m-34.187-5.725h6.734V89.828h-6.734Zm8.628,1.9H-97.643V87.933h10.522Z"
                  />
                </g>
              </g>
            </svg>
            Płyty
          </a>
          <a href="#" @click.prevent="scrollToId('kuchnie')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="41.58"
              height="50"
              viewBox="0 0 82.6 99.3"
              style="enable-background:new 0 0 82.6 99.3;"
              xml:space="preserve"
            >
              <path
                d="M76.8,34c0-1-0.8-1.7-1.7-1.7H7.9c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7H75C76,35.7,76.8,34.9,76.8,34"
              />
              <path
                d="M24.8,13.8v11.9H57V13.8H24.8z M54.6,23.3H27.2v-7h27.4V23.3z"
              />
              <path
                d="M7.5,42.8v39.5h68V42.8H7.5z M73,79.9H9.9V45.2H73V79.9z"
              />
              <path
                d="M69.4,0H13.5C6.2,0,0.3,5.9,0.3,13.2v73c0,7.3,5.9,13.2,13.2,13.2h55.9c7.3,0,13.2-5.9,13.2-13.2v-73 C82.6,5.9,76.7,0,69.4,0z M79.1,86.1c0,5.4-4.4,9.7-9.7,9.7H13.5c-5.4,0-9.7-4.4-9.7-9.7v-73c0-5.4,4.4-9.7,9.7-9.7h55.9 c5.4,0,9.7,4.4,9.7,9.7V86.1z"
              />
            </svg>
            Kuchnie
          </a>
        </div>
        <div class="nav-inner">
          <a href="#" @click.prevent="scrollToId('okapy')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="46.567"
              height="50"
              viewBox="0 0 46.567 50"
            >
              <defs>
                <clipPath id="a">
                  <rect
                    class="a"
                    width="46.567"
                    height="50"
                    transform="translate(-88.584 48.7)"
                  />
                </clipPath>
              </defs>
              <g transform="translate(88.584 -48.7)">
                <g class="b">
                  <path
                    class="a"
                    d="M-56.371,98.347c.7-1.492.156-2.627-.425-3.829-.1-.2-.195-.407-.293-.62-.348-.767-.135-1.336.874-2.345a.613.613,0,0,0,0-.872.619.619,0,0,0-.871,0c-1,1-1.84,2.151-1.124,3.724.1.227.2.443.306.65.587,1.219.853,1.848.422,2.764a.613.613,0,0,0,.294.821.621.621,0,0,0,.26.06.614.614,0,0,0,.557-.353m-8.042,0c.7-1.492.152-2.627-.429-3.829q-.144-.3-.293-.62c-.348-.767-.135-1.336.871-2.345a.613.613,0,0,0,0-.872.615.615,0,0,0-.868,0c-1.007,1.007-1.836,2.154-1.124,3.724.1.227.2.443.306.65.59,1.219.854,1.848.422,2.764a.614.614,0,0,0,.294.821.627.627,0,0,0,.263.06.619.619,0,0,0,.558-.353m-8.268,0c.7-1.492.153-2.63-.428-3.835-.1-.2-.195-.4-.294-.617-.35-.764-.137-1.336.872-2.342a.613.613,0,0,0,0-.872.616.616,0,0,0-.869,0c-1.009,1.007-1.839,2.151-1.123,3.724.1.227.2.44.306.644.59,1.225.856,1.854.422,2.77a.614.614,0,0,0,.293.821.638.638,0,0,0,.264.06.621.621,0,0,0,.557-.353M-86.834,87.233h43.068V81.605H-86.834Zm44.818,1.747H-88.584V79.853h46.568Zm-28.969-9.124h10.136V50.449H-70.985ZM-59.1,81.605H-72.735V48.7H-59.1Z"
                  />
                </g>
              </g>
            </svg>
            Okapy
          </a>
          <a href="#" @click.prevent="scrollToId('zmywarki')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="41.41"
              height="50"
              viewBox="0 0 41.41 50"
            >
              <defs>
                <clipPath id="a">
                  <rect
                    class="a"
                    width="41.41"
                    height="50"
                    transform="translate(200.662 48.7)"
                  />
                </clipPath>
              </defs>
              <g transform="translate(-200.662 -48.7)">
                <g class="b">
                  <path
                    class="a"
                    d="M207.3,50.444a4.9,4.9,0,0,0-4.894,4.894v36.72a4.9,4.9,0,0,0,4.894,4.9h28.134a4.9,4.9,0,0,0,4.891-4.9V55.338a4.9,4.9,0,0,0-4.891-4.894ZM235.436,98.7H207.3a6.65,6.65,0,0,1-6.641-6.642V55.338A6.647,6.647,0,0,1,207.3,48.7h28.134a6.642,6.642,0,0,1,6.635,6.638v36.72a6.645,6.645,0,0,1-6.635,6.642"
                  />
                  <path
                    class="a"
                    d="M203.308,59.76h-.821a.872.872,0,0,1,0-1.744h.821a.872.872,0,0,1,0,1.744"
                  />
                  <path
                    class="a"
                    d="M241.2,59.76H201.534a.872.872,0,0,1,0-1.744H241.2a.872.872,0,1,1,0,1.744"
                  />
                  <path
                    class="a"
                    d="M225.867,69.256h-9a.872.872,0,0,1,0-1.744h9a.872.872,0,0,1,0,1.744"
                  />
                </g>
              </g>
            </svg>
            Zmywarki
          </a>
          <a href="#" @click.prevent="scrollToId('lodówki')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="30.464"
              height="60"
              viewBox="0 0 30.464 60"
            >
              <defs>
                <clipPath id="a">
                  <rect
                    class="a"
                    width="30.464"
                    height="60"
                    transform="translate(-78.532 43.7)"
                  />
                </clipPath>
              </defs>
              <g transform="translate(78.532 -43.7)">
                <g class="b">
                  <path
                    class="a"
                    d="M-53.523,78.256a.6.6,0,0,0-.6-.6H-72.48a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.605h18.355a.6.6,0,0,0,.6-.605M-71.706,45.428a5.106,5.106,0,0,0-5.1,5.1V96.871a5.109,5.109,0,0,0,5.1,5.1H-54.9a5.112,5.112,0,0,0,5.1-5.1V50.532a5.109,5.109,0,0,0-5.1-5.1ZM-54.9,103.7H-71.706a6.833,6.833,0,0,1-6.824-6.829V50.532A6.836,6.836,0,0,1-71.706,43.7H-54.9a6.837,6.837,0,0,1,6.829,6.832V96.871A6.835,6.835,0,0,1-54.9,103.7M-70.184,49.172a3.725,3.725,0,0,0-3.725,3.72V94.511a3.728,3.728,0,0,0,3.725,3.724h13.768a3.727,3.727,0,0,0,3.72-3.724V52.892a3.723,3.723,0,0,0-3.72-3.72Zm13.768,50.792H-70.184a5.458,5.458,0,0,1-5.453-5.453V52.892a5.457,5.457,0,0,1,5.453-5.449h13.768a5.456,5.456,0,0,1,5.449,5.449V94.511a5.457,5.457,0,0,1-5.449,5.453"
                  />
                </g>
              </g>
            </svg>
            Lodówki
          </a>
        </div>
      </div>
    </div>

    <div v-for="(categoryVideos, categoryName) in videos" :key="categoryName">
      <!-- WSZYSTKIE KATEGORIE POZA PLYTAMI -->
      <categoryCarousel
        v-if="categoryName != 'płyty'"
        :videos="categoryVideos"
        :articles="articles[categoryName]"
        :categoryName="categoryName"
      ></categoryCarousel>
      <!-- PLYTY -->
      <div v-else class="car-container" :id="categoryName">
        <div class="car-inner">
          <div class="car-section-header">
            <div class="catIcoBox" v-html="catNameToIco"></div>
            <h2>{{ categoryName }}</h2>
          </div>
          <div class="car-header">
            <h2>Materiały video</h2>
          </div>
          <div class="car-box">
            <categoryTwinsLeft
              :videos="categoryVideos['gazowe']"
              :articles="articles[categoryName]['gazowe']"
              :categoryName="'Płyty gazowe'"
            ></categoryTwinsLeft>
            <categoryTwinsRight
              :videos="categoryVideos['indukcyjne']"
              :articles="articles[categoryName]['indukcyjne']"
              :categoryName="'Płyty indukcyjne'"
            ></categoryTwinsRight>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import categoryTwinsLeft from "./category_twins_left";
import categoryTwinsRight from "./category_twins_right";
import categoryCarousel from "./category_carousel";
import iconYT from "@/components/Icons/YouTube";

export default {
  data() {
    return {
      articles: {
        piekarniki: [],
        płyty: [],
        kuchnie: [],
        okapy: [],
        zmywarki: [],
        lodówki: []
      },
      videos: {
        piekarniki: [
          {
            youtube_id: "ar6or-Enrks",
            title: "Jaki piekarnik wybrać? – Grzegorz radzi",
            ico_name: ""
          },
          {
            youtube_id: "ILQdkRj6TEo",
            title: "Jak upiec idealnie? – BakingPro System®",
            ico_name: "bakingprosystem"
          },
          {
            youtube_id: "F5o_kC9ApO4",
            title: "Jak szybko rozgrzać piekarnik? - Nagrzew w 3 min",
            ico_name: "szybkinagrzew"
          },
          {
            youtube_id: "mjaaysVz8mQ",
            title: "Czy piekarnik może otworzyć się sam? – OpenUp!®",
            ico_name: "openup"
          },
          {
            youtube_id: "nhA66-Q5a9Q",
            title: "Co daje piekarnik parowy? - FullSteam",
            ico_name: "fullsteam"
          },
          {
            youtube_id: "bYvt0IrA29c",
            title: "Jak skutecznie wyczyścić piekarnik? – Pyroliza",
            ico_name: "pyroliza"
          },
          {
            youtube_id: "6ae3BzRsH_0",
            title: "Jak zdalnie sterować piekarnikiem? – WiFi",
            ico_name: "wifi"
          }
        ],
        płyty: {
          gazowe: [
            {
              youtube_id: "QpIMN-WUa0o",
              title: "Jaką płytę gazową wybrać?",
              ico_name: ""
            },
            {
              youtube_id: "vAGztxoEB2Y",
              title: "Jak nie rozgotować potraw? – Timer",
              ico_name: "timerg"
            },
            {
              youtube_id: "er0DdEktmlg",
              title: "Jak gotować efektywniej? – Palnik WOK",
              ico_name: "wokg"
            },
            {
              youtube_id: "1kOfNLC-OyU",
              title:
                "Jak swobodnie przesuwać garnki? - Stabilne ruszty żeliwne",
              ico_name: "rusztg"
            }
          ],
          indukcyjne: [
            {
              youtube_id: "odhPzSFLitI",
              title: "Wielozadaniowa płyta indukcyjna 2.0",
              ico_name: ""
            },
            {
              youtube_id: "09idFLOM3TY",
              title: "Płać mniej za prąd! – Energooszczędność",
              ico_name: ""
            },
            {
              youtube_id: "72b_D8Xnr_Y",
              title: "Montaż płyty w cienkim blacie – SlimHob",
              ico_name: ""
            },
            {
              youtube_id: "wCOXHdja5z4",
              title: "Gotowanie w nietypowych naczyniach - FlexiSpace",
              ico_name: ""
            },
            {
              youtube_id: "wkOm4Klur1U",
              title: "Gotowanie na obu polach jednocześnie - AutoBridge",
              ico_name: ""
            },
            {
              youtube_id: "APcq0aw7SIU",
              title: "Gotowanie wody w 60s! - PowerBooster",
              ico_name: ""
            },
            {
              youtube_id: "5Wh_5YT4-jI",
              title: "Jaką płytę indukcyjną wybrać?",
              ico_name: ""
            },
            {
              youtube_id: "Gi1txVPyC50",
              title: "Jak łatwiej gotować? - Hob&Go",
              ico_name: "hobgo"
            },
            {
              youtube_id: "FC3oXzeheUk",
              title: "Jak gotować na dwóch polach jednocześnie? - AutoBridge",
              ico_name: "autobridge"
            },
            {
              youtube_id: "tRP6VW7nZlM",
              title: "Czy można gotować w kwadratowym naczyniu? - FlexiSpace",
              ico_name: "flexispace"
            },

            {
              youtube_id: "fi9JeMQZdVU",
              title: "Jakie garnki nadają się do indukcji? - CheckPot",
              ico_name: "checkpot"
            }
          ]
        },
        kuchnie: [
          {
            youtube_id: "NDnITZ6oOjw",
            title: "Jaką kuchenkę wybrać? – Grzegorz radzi",
            ico_name: ""
          },
          {
            youtube_id: "LGaHKXVAK-4",
            title: "Jak wypiekać równomiernie? – BakingPro System®",
            ico_name: "bakingprosystem"
          },
          {
            youtube_id: "3m94KeoTWeo",
            title: "Jak szybko rozgrzać piekarnik? - Nagrzew w 3 min",
            ico_name: "szybkinagrzew"
          },
          {
            youtube_id: "JmIc8DHGc5c",
            title: "Co daje duża pojemność w kuchence? – Pojemność XXL",
            ico_name: "xxl"
          },
          {
            youtube_id: "ZgsjuY2tpoM",
            title:
              "Czy kuchenka jest bezpieczna dla dzieci? – Chłodny front (3 szyby)",
            ico_name: "chlodnyfront"
          },
          {
            youtube_id: "LicKz4E9QgQ",
            title: "Co daje podwójny płomień? - Palnik WOK",
            ico_name: "wok"
          },
          {
            youtube_id: "hv4MiIk8-6c",
            title: "Co daje stabilny ruszt? - Stabilne ruszty żeliwne",
            ico_name: "ruszty"
          },
          {
            youtube_id: "ZYgsXMu2m-0",
            title:
              "Jak wyczyścić kuchenkę bez detergentów? – Czyszczenie parowe",
            ico_name: "parowe"
          }
        ],
        okapy: [
          {
            youtube_id: "XmNeZv3cSbc",
            title: "Jaki okap wybrać? – Grzegorz radzi",
            ico_name: ""
          },
          {
            youtube_id: "YDLW596dm2M",
            title: "Czy można sterować okapem za pomocą gestu? - Touchless®",
            ico_name: "touchless"
          },
          {
            youtube_id: "1tb10oCvjbE",
            title: "Jak usunąć nieprzyjemne zapachy w kuchni? – FrameOn",
            ico_name: "frameon"
          },
          {
            youtube_id: "w8EW2HMQx78",
            title:
              "Jak dobrze oświetlić to, co się gotuje? - Potrójne oświetlenie LED",
            ico_name: "potrojneoswietlenieled"
          },
          {
            youtube_id: "ln6ZYvP7bec",
            title: "Co daje ozon w kuchni? - SmellFree",
            ico_name: "smellfree"
          }
        ],
        zmywarki: [
          {
            youtube_id: "kDgTr2uve8Y",
            title: "Jaką zmywarkę wybrać? – Grzegorz radzi",
            ico_name: ""
          },
          {
            youtube_id: "18eSVN49VSE",
            title: "Czy zmywarka domywa naczynia? – WaterSpinner",
            ico_name: "waterspinner"
          },
          {
            youtube_id: "xtUacdk-UtQ",
            title: "Czy naczynia ze zmywarki są suche? - TurboDrying",
            ico_name: "turbodrying"
          },
          {
            youtube_id: "uExXOe4wk2U",
            title: "Czy warto kupić zmywarkę? - Oszczędne zmywanie",
            ico_name: "niskiezuzyciewody"
          },
          {
            youtube_id: "j3HnQrTE98c",
            title: "Jak oszczędzić na zmywaniu? - Klasa Energetyczna A+++",
            ico_name: "klasaenergetyczna"
          },
          {
            youtube_id: "VWQdKKSd0IE",
            title: "Jak układać naczynia w zmywarce? - Up&Down",
            ico_name: "systemupdown"
          },
          {
            youtube_id: "jXI7O7K5G3c",
            title: "Manual zmywarek do zabudowy",
            ico_name: ""
          }
        ],
        lodówki: [
          {
            youtube_id: "qsV56Wk5rzg",
            title: "Jaką lodówkę wybrać? – Grzegorz radzi",
            ico_name: ""
          },
          {
            youtube_id: "C1O2y13mgt8",
            title: "Maksymalnie długo świeże warzywa i owoce? – FreshOn",
            ico_name: "freshon"
          },
          {
            youtube_id: "R7O_TvuVpeY",
            title: "Regulacja wilgotności w pojemniku – VitControl ",
            ico_name: "vitcontrol"
          },
          {
            youtube_id: "AAI8SGvmKFw",
            title: "Idealne miejsce dla ryb i mięsa? – FreshZone",
            ico_name: "freshzone"
          },
          {
            youtube_id: "aC8F_l1wPM4",
            title: "Koniec z rozmrażaniem lodówki! – Total NoFrost",
            ico_name: "totalnofrost"
          }
        ]
      }
    };
  },
  methods: {
    scrollToId: function(id) {
      this.$scrollTo("#" + id, 300, {
        easing: "ease",
        cancelable: false,
        offset: -100
      });
    }
  },
  computed: {
    catNameToIco: function() {
      return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70.575" height="50" viewBox="0 0 70.575 50"><defs><clipPath id="a"><rect class="a" width="70.575" height="50" transform="translate(-128.588 48.7)"/></clipPath></defs><g transform="translate(128.588 -48.7)"><g class="b"><path class="a" d="M-74.916,74.91a9.351,9.351,0,0,0-9.338,9.342A9.351,9.351,0,0,0-74.916,93.6a9.353,9.353,0,0,0,9.338-9.343,9.353,9.353,0,0,0-9.338-9.342m0,20.575A11.243,11.243,0,0,1-86.148,84.252,11.243,11.243,0,0,1-74.916,73.019,11.244,11.244,0,0,1-63.683,84.252,11.244,11.244,0,0,1-74.916,95.485m-34.928-17.4a7.617,7.617,0,0,0-7.606,7.606,7.618,7.618,0,0,0,7.606,7.61,7.615,7.615,0,0,0,7.606-7.61,7.614,7.614,0,0,0-7.606-7.606m0,17.111a9.516,9.516,0,0,1-9.5-9.505,9.512,9.512,0,0,1,9.5-9.5,9.509,9.509,0,0,1,9.5,9.5,9.512,9.512,0,0,1-9.5,9.505m34.39-41.218a7.613,7.613,0,0,0-7.6,7.606,7.614,7.614,0,0,0,7.6,7.61,7.62,7.62,0,0,0,7.615-7.61,7.619,7.619,0,0,0-7.615-7.606m0,17.111a9.511,9.511,0,0,1-9.5-9.505,9.511,9.511,0,0,1,9.5-9.5,9.512,9.512,0,0,1,9.505,9.5,9.513,9.513,0,0,1-9.505,9.505m-34.6-17.152a9.346,9.346,0,0,0-9.338,9.338,9.349,9.349,0,0,0,9.338,9.342,9.353,9.353,0,0,0,9.338-9.342,9.349,9.349,0,0,0-9.338-9.338m0,20.575A11.247,11.247,0,0,1-121.289,63.27a11.244,11.244,0,0,1,11.233-11.233A11.243,11.243,0,0,1-98.828,63.27a11.247,11.247,0,0,1-11.228,11.237M-125.038,50.6a1.99,1.99,0,0,0-1.655,2.166V94.639a1.99,1.99,0,0,0,1.655,2.166h63.476a1.965,1.965,0,0,0,1.655-2.166V52.761A1.965,1.965,0,0,0-61.562,50.6Zm63.476,48.1h-63.476a3.836,3.836,0,0,1-3.55-4.061V52.761a3.836,3.836,0,0,1,3.55-4.061h63.476a3.836,3.836,0,0,1,3.55,4.061V94.639a3.836,3.836,0,0,1-3.55,4.061m-34.187-5.725h6.734V89.828h-6.734Zm8.628,1.9H-97.643V87.933h10.522Z"/></g></g></svg>';
    }
  },
  mounted() {
    if (typeof window.grArticles != "undefined") {
      this.articles = window.grArticles;
    }
    // this.articles = JSON.parse(
    //   '{"piekarniki":[{"title":"Doskonałe wypieki to nie kwestia talentu, ale odpowiedniego piekarnika","url":"/grzegorz-radzi/artykuly/?artykul=doskonale_wypieki","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_4.jpg?1574075668","excerpt":"Urządzasz kuchnię i chcesz, żeby była miejscem nie tylko nowoczesnym i funkcjonalnym, ale również przyjaznym? Lubisz kulinarne eksperymenty, ale zbyt często kończą się one efektem niedopieczenia albo zakalcem? Potrzebujesz dobrego piekarnika!"},{"title":"Czysty piekarnik? Zawsze!","url":"/grzegorz-radzi/artykuly/?artykul=rzecz_o_czyszczeniu","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_5.jpg?1574075668","excerpt":"Amica od lat tworzy i testuje swoje sprzęty, podglądając ludzkie potrzeby. Dlatego najnowsze piekarniki — zarówno te do zabudowy, jak i te w kuchniach wolnostojących — wyposażone zostały w szereg rozwiązań wyręczających Cię w czyszczeniu albo bardzo je ułatwiających."}],"płyty":{"gazowe":[{"title":"Co warto wiedzieć o płytach Amica","url":"/grzegorz-radzi/artykuly/?artykul=co_warto_wiedziec_o_plytach_amica","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_9.jpg?1574075668","excerpt":"Jakiej płyty grzejnej potrzebujesz? Dobre pytanie. Na początek zastanów się, jak często gotujesz, jaką masz dużą kuchnię, ile osób liczy Twoja rodzina lub czy może jesteś nowoczesnym singlem jedzącym głównie na mieście. Odpowiedzi na te podstawowe pytania pomogą ci zawęzić krąg poszukiwanych sprzętów."},{"title":"Po prostu postaw i... gotuj!","url":"/grzegorz-radzi/artykuly/?artykul=po_prostu_postaw_i_gotuj","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_10.jpg?1574075668","excerpt":"Przekonamy Cię, że płyta indukcyjna to inwestycja doskonała: wyjątkowo funkcjonalna i po ludzku intuicyjna."}],"indukcyjne":[{"title":"Ile potrafi okap? Więcej niż myślisz","url":"/grzegorz-radzi/artykuly/?artykul=ile_potrafi_okap","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_17.jpg?1574075668","excerpt":"Żeby kuchnia była w pełni funkcjonalna, potrzebuje odpowiednio dobranego okapu. Tym bardziej, że ulubione pomieszczenie domowników zwykle łączy się dzisiaj z salonem, a w tym nie powinno być miejsca na intensywne zapachy i osady z tłuszczu."}]},"kuchnie":[{"title":"Gotowanie i pieczenie w jednym. O kuchniach wolnostojących","url":"/grzegorz-radzi/artykuly/?artykul=gotowanie_i_pieczenie_w_jednym","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_1.jpg?1574075668","excerpt":"Kuchnia wolnostojąca to wciąż najlepsze rozwiązanie do wielu kuchni, zwłaszcza tych niewielkich. Łączy w jednym urządzeniu wszystkie funkcje potrzebne do przyrządzania jedzenia, co bardzo wpływa na komfort takich działań."}],"okapy":[{"title":"Ile potrafi okap? Więcej niż myślisz","url":"/grzegorz-radzi/artykuly/?artykul=ile_potrafi_okap","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_17.jpg?1574075668","excerpt":"Żeby kuchnia była w pełni funkcjonalna, potrzebuje odpowiednio dobranego okapu. Tym bardziej, że ulubione pomieszczenie domowników zwykle łączy się dzisiaj z salonem, a w tym nie powinno być miejsca na intensywne zapachy i osady z tłuszczu."}],"zmywarki":[{"title":"Sposób na perfekcyjnie czyste naczynia","url":"/grzegorz-radzi/artykuly/?artykul=sposob_na_perfekcyjnie_czyste_naczynia","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_7.jpg?1574075668","excerpt":"Czego oczekujesz od swojej zmywarki? No cóż… Przede wszystkim powinna myć naczynia perfekcyjnie – nawet te z mocno przypalonym tłuszczem, czyli dokładnie tak, jak w reklamach środków do zmywarek. Ale czy skuteczność zmywania to wyłączny efekt działania magicznych tabletek, proszków lub kapsułek?"}],"lodówki":[{"title":"Przechowuję, nie marnuję!","url":"/grzegorz-radzi/artykuly/?artykul=przechowuje_nie_marnuje","img":"https://www.amica.pl/theme/Modern/img/View/grzegorz-articles/460x260_14.jpg?1574075668","excerpt":"Media i naukowcy alarmują: każdego dnia marnujemy ogromne ilości jedzenia! A statystyczny Polak? Ponad 230 kilogramów rocznie. Te dane są naprawdę bardzo niepokojące. A przecież można zmniejszyć skalę marnotrawstwa żywności, np. poprzez jej lepsze przechowywanie. Nowoczesne rozwiązania dostępne w lodówkach Amica mogą Ci w tym pomóc."}]}'
    // );
  },
  components: {
    categoryTwinsLeft,
    categoryTwinsRight,
    categoryCarousel,
    iconYT
  }
};
</script>

<style lang="scss" scoped>
.car-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin-bottom: 50px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 30px;
  }

  .car-inner {
    width: 91.67vw;
    height: auto;
    padding: 0 20px;

    @media only screen and (max-width: 991px) {
      width: 100vw;
    }

    .car-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      padding-right: calc(100vw / 12 * 1);
      padding-top: 25px;
      padding-bottom: 12px;
      margin-bottom: 20px;
      border-bottom: 1px #d3cec4 solid;

      &::after {
        content: "";
        background-color: #e41429;
        height: 3px;
        width: 74px;
        display: block;
        position: absolute;
        bottom: -2px;
        left: 0;
      }

      @media only screen and (max-width: 768px) {
        padding-right: 0px;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 15px;
      }

      svg {
        width: 52px;
        fill: #e41429;
        margin-left: 10px;
      }

      h2 {
        font-family: "Uni neue";
        color: rgb(63, 63, 63);
        font-weight: 400;
        font-size: 30px;
        text-transform: uppercase;
        margin-left: 0;
        font-weight: 700;
      }
    }
    .car-box {
      display: flex;
      width: 90%;
      justify-content: space-between;
      align-items: flex-start;

      @media only screen and (max-width: 1340px) {
        flex-direction: column;
        width: 98%;
      }
    }
  }
}
#header {
  width: 100%;
  min-height: 31.25vw;
  background: url("../../../assets/images/video_aggregator/heading.jpg")
    no-repeat;
  background-position: 50% 0%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  @media only screen and (max-width: 768px) {
  }

  .inner {
    width: calc(100vw / 12 * 5);
    margin-right: calc(100vw / 12 * 2);
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;

    @media only screen and (max-width: 1199px) {
      width: calc(100vw / 12 * 6);
      margin-right: calc(100vw / 12 * 2);
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 60%;
      top: -20%;
      left: 50px;
      z-index: 0;
      padding-top: 100%;
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OTQiIGhlaWdodD0iNDk0IiB2aWV3Qm94PSIwIDAgNDk0IDQ5NCI+PGRlZnM+PHN0eWxlPi5hLC5je2ZpbGw6bm9uZTt9LmF7c3Ryb2tlOiNlNDE0Mjk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjRweDtzdHJva2UtZGFzaGFycmF5OjQwO30uYntzdHJva2U6bm9uZTt9PC9zdHlsZT48L2RlZnM+PGcgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIyNDMiIGN5PSIyNDMiIHI9IjI0MyIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSIyNDMiIGN5PSIyNDMiIHI9IjI0NSIvPjwvZz48L3N2Zz4=");
      background-size: contain;
      background-repeat: no-repeat;

      @media only screen and (max-width: 768px) {
        display: none;
      }
    }

    h1 {
      font-size: 2.6041vw;
      color: #fff;
      text-shadow: 0px 3px 3px rgba(39, 36, 29, 0.85);
      letter-spacing: 1px;
      position: relative;
      z-index: 1;
    }

    h2 {
      font-size: 5.2083vw;
      color: #fff;
      font-weight: 600;
      text-shadow: 0px 3px 3px rgba(39, 36, 29, 0.85);
      position: relative;
      z-index: 1;
    }

    .actions {
      margin-top: 80px;

      @media only screen and (max-width: 1199px) {
        margin-top: 40px;
      }

      @media only screen and (max-width: 768px) {
        display: none;
      }

      a {
        color: #fff;
        font-size: 18px;
        position: relative;
        z-index: 3;

        @media only screen and (max-width: 1199px) {
          display: block;
          text-align: center;
        }

        &.btn-red {
          padding: 18px 40px;
          background: -webkit-gradient(
            linear,
            left top,
            right top,
            from(#ae0b11),
            to(#e41429)
          );
          background: linear-gradient(90deg, #ae0b11, #e41429);
          border-radius: 10px;

          @media only screen and (max-width: 1199px) {
            margin-bottom: 10px;
          }

          &:hover {
            text-decoration: none;
            background: #e41429;
          }
        }

        &.btn-transparent {
          // margin-left: 25px;
          padding: 16px 40px 16px 30px;
          border-radius: 10px;
          border: 2px #fff solid;

          -webkit-transition: all 0.1s ease-in-out;
          -moz-transition: all 0.1s ease-in-out;
          -o-transition: all 0.1s ease-in-out;
          transition: all 0.1s ease-in-out;

          @media only screen and (max-width: 1199px) {
            margin-left: 0px;
          }

          &:hover {
            text-decoration: none;
            background: #fff;
            color: #e41429;

            svg {
              fill: #e41429;
            }
          }

          svg {
            width: 30px;
            margin-right: 10px;
            margin-top: -2px;
            fill: #fff;
          }
        }
      }
    }
  }
}

.header-mobile-actions {
  max-width: 100%;
  margin-top: 10px;
  display: none;
  flex-direction: column;
  overflow: hidden;
  padding: 0 10px;

  @media only screen and (max-width: 768px) {
    display: flex;
  }

  a {
    color: #fff;
    font-size: 18px;
    position: relative;
    z-index: 3;

    @media only screen and (max-width: 1199px) {
      display: block;
      text-align: center;
    }

    &.btn-red {
      padding: 18px 40px;
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#ae0b11),
        to(#e41429)
      );
      background: linear-gradient(90deg, #ae0b11, #e41429);
      border-radius: 10px;

      @media only screen and (max-width: 1199px) {
        margin-bottom: 10px;
      }

      &:hover {
        text-decoration: none;
        background: #e41429;
      }
    }

    &.btn-transparent {
      margin-left: 25px;
      padding: 16px 40px 16px 30px;
      border-radius: 10px;
      border: 2px #e41429 solid;
      color: #e41429;

      -webkit-transition: all 0.1s ease-in-out;
      -moz-transition: all 0.1s ease-in-out;
      -o-transition: all 0.1s ease-in-out;
      transition: all 0.1s ease-in-out;

      @media only screen and (max-width: 1199px) {
        margin-left: 0px;
      }

      &:hover {
        text-decoration: none;
        background: #fff;
        color: #e41429;

        svg {
          fill: #e41429;
        }
      }

      svg {
        width: 30px;
        margin-right: 10px;
        margin-top: -2px;
        fill: #e41429;
      }
    }
  }
}

#copy-section {
  width: 100%;
  padding: 60px 0;
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding-top: 40px;
  }

  .copy-left {
    width: calc(100vw / 12 * 4);
    margin-left: calc(100vw / 12 * 1);
    padding-right: calc(100vw / 12 * 0.5);

    @media only screen and (max-width: 768px) {
      width: 100%;
      margin-left: 0px;
      padding: 0 20px;
    }

    p {
      color: #27241d;
      font-size: 48px;

      @media only screen and (max-width: 1440px) {
        font-size: 40px;
      }

      @media only screen and (max-width: 1024px) {
        font-size: 34px;
      }
    }
  }

  .copy-right {
    width: calc(100vw / 12 * 5);

    @media only screen and (max-width: 768px) {
      width: 100%;
      padding: 0 20px;
    }

    p {
      color: #857f72;
      font-size: 20px;
      font-weight: 400;
      line-height: 38px;

      @media only screen and (max-width: 1440px) {
        font-size: 16px;
        line-height: 32px;
      }

      @media only screen and (max-width: 1024px) {
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
}

#carousels-nav {
  // background: #FAF9F7;
  padding-bottom: 60px;
  padding-top: 60px;
  margin: 0 calc(100vw / 10);

  background: rgb(250, 249, 247);
  background: -moz-linear-gradient(
    top,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 70%,
    rgba(255, 255, 255, 1) 70%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 70%,
    rgba(255, 255, 255, 1) 70%
  );
  background: linear-gradient(
    to bottom,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 69%,
    rgba(250, 249, 247, 1) 70%,
    rgba(255, 255, 255, 1) 70%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#faf9f7', endColorstr='#ffffff',GradientType=0 );

  @media only screen and (max-width: 768px) {
    display: none;
  }

  h2 {
    color: #e41429;
    font-size: 42px;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
    padding-left: 20px;
    padding-right: 20px;
  }

  .nav-inner {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: space-between;

    a {
      font-family: "Lato";
      margin: 1%;
      min-height: 240px;
      height: 18.4375vw;
      min-width: 160px;
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      border: 1px #e41429 solid;
      border-radius: 10px;
      color: #d3cec4;
      font-size: 24px;
      text-transform: uppercase;
      position: relative;

      @media only screen and (max-width: 1024px) {
        font-size: 18px;
      }

      svg {
        margin-bottom: 50px;
        fill: #e41429;
      }

      &:hover {
        text-decoration: none;
        color: #fff;

        background: rgb(228, 20, 41);
        background: -moz-linear-gradient(
          top,
          rgba(228, 20, 41, 1) 0%,
          rgba(171, 9, 30, 1) 100%
        );
        background: -webkit-linear-gradient(
          top,
          rgba(228, 20, 41, 1) 0%,
          rgba(171, 9, 30, 1) 100%
        );
        background: linear-gradient(
          to bottom,
          rgba(228, 20, 41, 1) 0%,
          rgba(171, 9, 30, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e41429', endColorstr='#ab091e',GradientType=0 );

        &:after {
          content: "";
          display: block;
          position: absolute;
          width: 120px;
          height: 120px;
          top: 50%;
          left: 50%;
          z-index: 2;
          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTIwIDEyMCI+PGRlZnM+PHN0eWxlPi5hLC5je2ZpbGw6bm9uZTt9LmF7c3Ryb2tlOiNmODZhNmE7c3Ryb2tlLXdpZHRoOjNweDtzdHJva2UtZGFzaGFycmF5OjEwO30uYntzdHJva2U6bm9uZTt9PC9zdHlsZT48L2RlZnM+PGcgY2xhc3M9ImEiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSI2MCIgY3k9IjYwIiByPSI2MCIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSI2MCIgY3k9IjYwIiByPSI1OC41Ii8+PC9nPjwvc3ZnPg==");
          background-size: contain;
          background-repeat: no-repeat;

          -webkit-transform: translateX(-50%) translateY(-50%);
          -moz-transform: translateX(-50%) translateY(-50%);
          -ms-transform: translateX(-50%) translateY(-50%);
          -o-transform: translateX(-50%) mtranslateY(-50%);
          transform: translateX(-50%) translateY(-50%);

          margin-top: -45px;

          @media only screen and (max-width: 1024px) {
            display: none;
          }
        }

        svg {
          fill: #fff;
        }
      }
    }
  }
}
</style>
